import { useState, useEffect, useCallback } from 'react';

const useForm = (initialState, validators, callback) => {
  const [state, setState] = useState(initialState);
  const [disable, setDisable] = useState(true);
  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (Object.keys(initialState).length > 0) {
      setState(initialState);
    }
  }, [initialState]);

  useEffect(() => {
    if (isDirty) {
      setDisable(validateState());
    }
  }, [state, isDirty]);

  const validateState = useCallback(() => {
    if (validators) {
      const hasErrorInState = Object.keys(validators).some((key) => {
        const stateError = state[key]?.error;
        return stateError;
      });

      return hasErrorInState;
    }

    return false;
  }, [state, validators]);

  const handleOnChange = useCallback(
    (e) => {
      setIsDirty(true);

      const name = e.target.name;
      const value = e.target.value;

      let error = '';

      if (validators && typeof validators[name] === 'function') {
        error = validators[name](value);
      }

      setState((prevState) => {
        return {
          ...prevState,
          [name]: { ...prevState[name], value, error },
        };
      });
    },
    [validators]
  );

  const handleResetForm = useCallback(() => {
    setState(initialState);
    setIsDirty(false);
    setDisable(true);
  }, []);

  const handleOnSubmit = useCallback(
    (e) => {
      e.preventDefault();

      if (!validateState()) {
        callback(state, handleResetForm);
      }
    },
    [state, callback, handleResetForm]
  );

  return {
    state,
    setState,
    disable,
    handleOnChange,
    handleResetForm,
    handleOnSubmit,
  };
};

export default useForm;
